import loading from './loading.vue';
import intro from './intro.vue';
import Home from './Home.vue';
import mainLanding from './mainLanding.vue';
import questionSet from './questionSet.vue';
import share from './share.vue';
import shareForm from './shareForm.vue';

export default {
    loading,
    intro,
    Home,
    mainLanding,
    questionSet,
    share,
    shareForm
}